import { NavigationItem } from 'app/core/navigation/navigation.types';
import { UserRole } from '../user/user.types';

export interface NavigationItemWithRoles extends NavigationItem {
    role?: string[];
}

export const horizontalNavigation: NavigationItemWithRoles[] = [
    { id: 'how-it-works', title: 'How it works', type: 'basic', icon: 'heroicons_outline:question-mark-circle', link: '/how-it-works' },
    { id: 'dashboard', title: 'Dashboard', type: 'basic', role: [UserRole.basic, UserRole.advanced, UserRole.admin], icon: 'heroicons_outline:user', link: '/dashboard' },
    { id: 'project', title: 'Browse Projects', type: 'basic', icon: 'heroicons_outline:cube-transparent', link: '/projects' },
    { id: 'funding-opportunities', title: 'Funding Opportunities', type: 'basic', icon: 'heroicons_outline:circle-stack', link: '/funding-opportunities' },
    { id: 'messages', title: 'Messages', type: 'basic', icon: 'heroicons_outline:inbox', role: [UserRole.basic, UserRole.advanced, UserRole.admin], link: '/messages' },
    { id: 'admin', title: 'Admin', type: 'basic', icon: 'heroicons_outline:identification', role: [UserRole.admin], link: '/admin' },
];
